export default __webpack_public_path__ + "static/media/flag-india.baaff04e.svg";